import { PageContentExterneDto } from '../../../services/dtos/page-content-externe.dto';
import { updateFieldContent } from '../../../services/page.service';
import { AxiosError } from 'axios';
import { showAxiosMessageError } from '../../../services/error-message.service';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import React, { useState } from 'react';
import TitleBlockForm from '../../forms/edit-field-content/title-block/title-block.form';
import ContentBlockForm from '../../forms/edit-field-content/content-block/content-block.form';
import ImageBlockForm from '../../forms/edit-field-content/image-block/image-block.form';

/**
 * EditContent method is responsible for rendering different forms based on the codeChamps field of props.fieldContent.
 * It handles form submission and updates the content of the field using the updateFieldContent method. It also displays
 * success or error message using a snackbar.
 *
 * @param {Object} props - The props object containing fieldContent.
 * @param {PageContentExterneDto} props.fieldContent - The field content object.
 *
 * @return {JSX.Element|null} - The rendered form based on the codeChamps value of props.fieldContent.
 */
export default function EditContent(props: { fieldContent: PageContentExterneDto }): JSX.Element {
    // SnackBar pour les messages
    const showMessage = useSnackbars();

    // Désactive le bouton submit pour éviter le spam
    const [validate, setValidate] = useState(false);

    const iniValues = {
        contenu: props.fieldContent.valeur,
    };

    // Submit les nouvelles données
    const handleSubmit = (e: { contenu: string }): void => {
        setValidate(true);

        let newFieldContent = {
            codePage: props.fieldContent.codePage,
            codeChamps: props.fieldContent.codeChamps,
            valeur: e.contenu,
        };

        updateFieldContent(props.fieldContent['@id'], newFieldContent)
            .then(() => {
                showMessage.successAlert(
                    `Le champ ${props.fieldContent.codeChamps} de la page ${props.fieldContent.codePage} a bien été modifié.`
                );
            })
            .catch((error: Error | AxiosError) => {
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                setValidate(false);
            });
    };

    // Render le component nécessaire à la modification du champ en fonction du type de champ à modifier
    switch (props.fieldContent?.codeChamps) {
        case 'content':
            return (
                <ContentBlockForm fieldContent={props.fieldContent} validate={validate} handleSubmit={handleSubmit} />
            );
        case 'image':
            return <ImageBlockForm fieldContent={props.fieldContent} validate={validate} handleSubmit={handleSubmit} />;
        default:
            return (
                <TitleBlockForm
                    fieldContent={props.fieldContent}
                    validate={validate}
                    handleSubmit={handleSubmit}
                    iniValues={iniValues}
                />
            );
    }
}
